<template>
  <div>
    <el-dialog
      :title="title"
      custom-class="MyDialog"
      :visible.sync="openEntryDialogVisible"
      width="585px"
      :before-close="entryClose"
      label-position:right
      :close-on-click-modal="false"
      v-loading="loading"
    >
      <div style="margin-bottom: 20px">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="ruleFormSty"
        >
          <el-form-item label="入门账号额度：" prop="remainUseNum">
            <div>{{ remainUseNum }}</div>
          </el-form-item>
          <el-form-item label="开通客户：" prop="showCustomInfo">
            <el-autocomplete
              class="inline-input"
              v-model="ruleForm.showCustomInfo"
              :fetch-suggestions="querySearch"
              placeholder="请输入手机号或姓名"
              :value-key="'showCustomInfo'"
              :trigger-on-focus="false"
              :disabled="entryObj?.customId ? true : false"
              @input="inputChange"
              @select="handleSelect"
            >
            <template slot-scope="{ item }">
              <div v-if="item.customId == ''">没有查询到客户</div>
              <div v-else>{{ item.showCustomInfo }}</div>
            </template>
          </el-autocomplete>
          </el-form-item>
          <!-- <el-form-item label="开通客户：" prop="showCustomInfo">
            <el-select
              v-model="ruleForm.showCustomInfo"
              filterable
              remote
              reserve-keyword
              placeholder="请输入手机号或姓名"
              :disabled="entryObj?.customId ? true : false"
              :remote-method="querySearch"
              @change="handleSelect"
            >
              <el-option
                v-for="(item, index) in nameOptions"
                :key="index"
                :label="item.showCustomInfo"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="体验有效期：" prop="dates">
            <div>{{ today }}至{{ futureDate }}</div>
          </el-form-item>
          <el-form-item label="学习机：" prop="showSnInfo">
            <el-autocomplete
              class="inline-input"
              v-model="ruleForm.showSnInfo"
              :fetch-suggestions="snQuerySearch"
              placeholder="学习机型号或SN码"
              :value-key="'showSnInfo'"
              :trigger-on-focus="false"
              @input="closeSn"
              @select="snChange"
            >
            <template slot-scope="{ item }">
              <div v-if="item.snCode == ''">没有查询到学习机</div>
              <div v-else>{{ item.showSnInfo }}</div>
            </template>
            </el-autocomplete>
            <!-- <el-select
              v-model="ruleForm.showSnInfo"
              filterable
              ref="nameSel"
              remote
              reserve-keyword
              placeholder="请输入商品信息"
              :remote-method="snQuerySearch"
              @change="snChange"
              @blur="handleBlur"
            >
              <el-option
                v-for="(item, index) in snOptions"
                :key="index"
                :label="item.showSnInfo"
                :value="item"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="entryClose">取 消</el-button>
        <el-button
          type="primary"
          @click="openEntryConfirm"
          round
          :disabled="!remainUseNum"
          >保存</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="入门账号开通成功"
      custom-class="MyDialog"
      :visible.sync="successDialog"
      width="585px"
      label-position:right
    >
      <el-descriptions
        class="margin-top"
        :column="1"
        labelClassName="w_lableSty"
        contentClassName="w_contentSty"
      >
        <el-descriptions-item label="客户姓名">{{
          successObj.name
        }}</el-descriptions-item>
        <el-descriptions-item label="客户账号"
          >{{ successObj.accountUser }}
          <span class="copySty" @click="copyToClipboard(successObj.accountUser)"
            >复制</span
          ></el-descriptions-item
        >
        <el-descriptions-item label="密码" :span="20"
          >{{ stu_password }}
          <span class="copySty" @click="copyToClipboard(stu_password)"
            >复制</span
          ></el-descriptions-item
        >
        <el-descriptions-item label="体验日期">
          <div>{{ successObj.time }}</div>
        </el-descriptions-item>
        <el-descriptions-item label="学习机">
          <div>{{ successObj.snCode }}</div>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAgentRemainUseNum,
  queryCustomInfo,
  queryMachineInfo,
  openBeginnerAccountInfo,
} from "@/api/AuditionManage";
import { getGwPasswordStr } from "@/api/AccountInterface";
import Template from "@/views/Home/financeCenter/AgentAccount/template.vue";

export default {
  name: "openEntry",
  props: {
    openEntryDialogVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "入门账号开通",
    },
    entryObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      analystList: [],
      options: [
        {
          value: "1",
          label: "学习机1",
        },
        {
          value: "2",
          label: "学习机2",
        },
      ],
      nameOptions: [], // 客户姓名
      snOptions: [], // 学习机
      successDialog: false,
      loading: false,
      ruleForm: {
        name: "",
        snCode: "",
        showSnInfo: "",
        showCustomInfo: "",
        customId: "",
        mobile: "",
      },
      rules: {},
      today: "",
      futureDate: "",
      remainUseNum: 0, // 剩余使用次数
      userInfo: {},
      successObj: {}, // 开通成功信息
      stu_password: "",
    };
  },
  components: { Template },
  watch: {
    openEntryDialogVisible(val) {
      console.log(val, "val");

      if (val) {
        this.getAgentRemainUseNum();
        this.snOptions = [];
        this.nameOptions = [];
        this.ruleForm.mobile = this.entryObj?.mobile || "";

        const isName = this.entryObj?.customName || this.entryObj?.studentName;
        this.ruleForm.name = isName || "";
        this.ruleForm.showCustomInfo = isName
          ? `${isName}-${this.entryObj?.mobile}`
          : "";
      } else {
        this.$refs.ruleForm.resetFields();
        this.ruleForm={
             name: "",
        snCode: "",
        showSnInfo: "",
        showCustomInfo: "",
        customId: "",
        mobile: "",
        }
      }
    },
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("agent_user_info")) || {};

    this.getCurrentDateTo93DaysLater();
    this.getAgentRemainUseNum();
  },
  methods: {
    // 远程搜索
    querySearch(query, cb) {
      if (query !== "") {
        let param = {
          campusId: this.entryObj?.campusId || this.userInfo.campusId,
          nameOrMobile: query,
        };
        queryCustomInfo(param)
          .then((res) => {
            if (res.code === 0) {
              this.nameOptions = [];
              if (res.data.length > 0) {
                this.nameOptions = res.data;
              } else {
                this.nameOptions.push({
                  "customId": '',
                  "showCustomInfo": "没有查询到客户"
                })
              }
              console.log(this.nameOptions, "this.nameOptions");
              cb(this.nameOptions);
            }
          })
          .finally(() => {
            this.$nextTick(() => {});
          });
      } else {
        this.nameOptions = [];
      }
    },
    handleBlur(value) {
      console.log(value, "value");

      this.ruleForm.showSnInfo = this.$refs.nameSel.selectedLabelo;
    },
    snQuerySearch(query, cb) {
      if (query !== "") {
        let param = {
          campusId: this.entryObj?.campusId || this.userInfo.campusId,
          machineNameOrSnCode: query,
        };
        queryMachineInfo(param)
          .then((res) => {
            if (res.code === 0) {
              this.snOptions = [];
              if (res.data.length > 0) {
                this.snOptions = res.data;
              } else {
                this.snOptions.push({
                  "snCode": '',
                  "showSnInfo": "没有查询到学习机"
                })
              }
              cb(this.snOptions);
            }
          })
          .finally(() => {
            this.$nextTick(() => {});
          });
      } else {
        this.snOptions = [];
      }
    },

    handleSelect(item) {
      if (item.showCustomInfo != '没有查询到客户') {
        this.ruleForm = {
          ...this.ruleForm,
          ...item,
        };
        console.log(this.ruleForm, "item");
      } else {
        this.ruleForm.showCustomInfo = '';
      }
    },
    inputChange(val){
      this.ruleForm.mobile = '';
      this.ruleForm.name = '';
      this.ruleForm.customId = '';
    },
    snChange(item) {
      if (item.showSnInfo != '没有查询到学习机') {
        this.ruleForm.snCode = item.snCode;
        this.ruleForm.showSnInfo = item.showSnInfo;
      } else {
        this.ruleForm.showSnInfo = '';
      }
      console.log(item, "item");
      // this.ruleForm.showSnInfo = item;
    },
    // 清空sn
    closeSn(val) {
      this.ruleForm.snCode = "";
    },
    getAgentRemainUseNum() {
      getAgentRemainUseNum().then((res) => {
        if (res.code === 0) {
          this.remainUseNum = res.data?.remainUseNum || 0;
        }
      });
    },
    entryClose() {
      this.$emit("entryClose");
    },
    openEntryConfirm() {
      let customId = this.ruleForm?.customId || this.entryObj?.customId || "";
      let snCode = this.ruleForm.snCode;
      if (customId == '') {
        this.$message.warning("请输入正确开通客户信息");
        return;
      }
      if (snCode == "") {
        this.$message.warning("请输入正确学习机信息");
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = {
            campusId: this.userInfo.campusId || "",
            customId: this.ruleForm?.customId || this.entryObj?.customId || "",
            mobile: this.ruleForm.mobile || "",
            name: this.ruleForm.name,
            snCode: this.ruleForm.snCode,
          };
          openBeginnerAccountInfo(params)
            .then((res) => {
              if (res.code === 0) {
                this.$nextTick(() => {
                  this.$refs.ruleForm.resetFields();
                });
                this.$emit("openEntryConfirm");
                this.successObj = res.data;
                this.getPasswordStr(res.data.customId);
                this.successDialog = true;
              } else {
                this.$message.error(res.message);
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    async getPasswordStr(param) {
      const params = {
        customId: param || "",
      };
      await getGwPasswordStr(params).then((ret) => {
        this.stu_password = ret.data;
      });
    },

    getCurrentDateTo93DaysLater() {
      const today = new Date();
      const futureDate = new Date();
      futureDate.setDate(today.getDate() + 93);

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      this.today = formatDate(today);
      this.futureDate = formatDate(futureDate);
      return {
        today: formatDate(today),
        futureDate: formatDate(futureDate),
      };
    },
    // 复制到剪贴板
    copyToClipboard(txt) {
      if (navigator.clipboard) {
        // clipboard api 复制
        navigator.clipboard.writeText(txt);
      } else {
        var textarea = document.createElement("textarea");
        document.body.appendChild(textarea);
        // 隐藏此输入框
        textarea.style.position = "fixed";
        textarea.style.clip = "rect(0 0 0 0)";
        textarea.style.top = "10px";
        // 赋值
        textarea.value = txt;
        // 选中
        textarea.select();
        // 复制
        document.execCommand("copy", true);
        // 移除输入框
        document.body.removeChild(textarea);
      }

      this.$message.success("复制成功");
    },
  },
};
</script>
<style scoped lang="scss">
.copySty {
  color: #409eff;
  cursor: pointer;
  margin-left: 10px;
}
.el-select,
.el-autocomplete {
  width: 100%;
}
.el-select-dropdown__item.selected {
  color: #606266;
  font-weight: 400;
}
</style>
<style>
.w_lableSty,
.w_contentSty {
  font-size: 18px;
  color: #000;
  min-width: 150px;
  margin-bottom: 20px;
}
.w_lableSty {
  margin-right: 40px;
}
</style>
